import { FreelancerFeedbackCommonData, FreelancerFeedbackItem } from '../../typings/freelancers';

export const ADD_FREELANCER_FEEDBACK_START = 'ADD_FREELANCER_FEEDBACK_START';
export type ADD_FREELANCER_FEEDBACK_START = typeof ADD_FREELANCER_FEEDBACK_START;

export const ADD_FREELANCER_FEEDBACK_SUCCESS = 'ADD_FREELANCER_FEEDBACK_SUCCESS';
export type ADD_FREELANCER_FEEDBACK_SUCCESS = typeof ADD_FREELANCER_FEEDBACK_SUCCESS;

export const UPDATE_FREELANCER_FEEDBACK_START = 'UPDATE_FREELANCER_FEEDBACK_START';
export type UPDATE_FREELANCER_FEEDBACK_START = typeof UPDATE_FREELANCER_FEEDBACK_START;

export const UPDATE_FREELANCER_FEEDBACK_SUCCESS = 'UPDATE_FREELANCER_FEEDBACK_SUCCESS';
export type UPDATE_FREELANCER_FEEDBACK_SUCCESS = typeof UPDATE_FREELANCER_FEEDBACK_SUCCESS;

export const DELETE_FREELANCER_FEEDBACK_START = 'DELETE_FREELANCER_FEEDBACK_START';
export type DELETE_FREELANCER_FEEDBACK_START = typeof DELETE_FREELANCER_FEEDBACK_START;

export const DELETE_FREELANCER_FEEDBACK_SUCCESS = 'DELETE_FREELANCER_FEEDBACK_SUCCESS';
export type DELETE_FREELANCER_FEEDBACK_SUCCESS = typeof DELETE_FREELANCER_FEEDBACK_SUCCESS;

export interface AddFreelancerFeedbackStartActionParams extends FreelancerFeedbackCommonData {
    freelancerId: string;
}

export enum FreelancerFeedbackErrorCode {
    OPERATOR_HAS_NO_PROJECT_WITH_FREELANCER = 'FreelancerDefects.FeedbackDefects.OPERATOR_HAS_NO_PROJECT_WITH_FREELANCER',
    OPERATOR_IS_NOT_CHIEF = 'FreelancerDefects.FeedbackDefects.OPERATOR_IS_NOT_CHIEF',
    OPERATOR_HAS_WRONG_ROLE = 'FreelancerDefects.FeedbackDefects.OPERATOR_HAS_WRONG_ROLE',
    INCORRECT_FEEDBACK_TEXT_SIZE = 'FreelancerDefects.FeedbackDefects.INCORRECT_FEEDBACK_TEXT_SIZE',
    FEEDBACK_NOT_FOUND = 'FreelancerDefects.FeedbackDefects.FEEDBACK_NOT_FOUND',
    FEEDBACK_ALREADY_EXIST = 'FreelancerDefects.FeedbackDefects.FEEDBACK_ALREADY_EXIST'
}

export interface FreelancerFeedbackError {
    code: FreelancerFeedbackErrorCode;
}

export interface UpdateFreelancerFeedbackStartActionParams extends AddFreelancerFeedbackStartActionParams {
    feedbackId: string;
}

export interface AddFreelancerFeedbackStartAction {
    type: ADD_FREELANCER_FEEDBACK_START;
    payload: AddFreelancerFeedbackStartActionParams;
}

export interface AddFreelancerFeedbackSuccessAction {
    type: ADD_FREELANCER_FEEDBACK_SUCCESS;
    freelancerId: string;
    payload: FreelancerFeedbackItem;
}

export interface UpdateFreelancerFeedbackStartAction {
    type: UPDATE_FREELANCER_FEEDBACK_START;
    payload: UpdateFreelancerFeedbackStartActionParams;
}

export interface UpdateFreelancerFeedbackSuccessAction {
    type: UPDATE_FREELANCER_FEEDBACK_SUCCESS;
    payload: FreelancerFeedbackItem;
}

export interface DeleteFreelancerFeedbackStartActionParams {
    feedbackItemId: string;
    freelancerId: string;
}

export interface DeleteFreelancerFeedbackStartAction {
    type: DELETE_FREELANCER_FEEDBACK_START;
    payload: DeleteFreelancerFeedbackStartActionParams;
}

export interface DeleteFreelancerFeedbackSuccessAction {
    type: DELETE_FREELANCER_FEEDBACK_SUCCESS;
    payload: DeleteFreelancerFeedbackStartActionParams;
}

export function addFreelancerFeedbackStart(
    payload: AddFreelancerFeedbackStartActionParams
): AddFreelancerFeedbackStartAction {
    return {
        type: ADD_FREELANCER_FEEDBACK_START,
        payload
    };
}

export function addFreelancerFeedbackSuccess(
    freelancerId: string,
    payload: FreelancerFeedbackItem
): AddFreelancerFeedbackSuccessAction {
    return {
        type: ADD_FREELANCER_FEEDBACK_SUCCESS,
        freelancerId,
        payload
    };
}

export function updateFreelancerFeedbackStart(
    payload: UpdateFreelancerFeedbackStartActionParams
): UpdateFreelancerFeedbackStartAction {
    return {
        type: UPDATE_FREELANCER_FEEDBACK_START,
        payload
    };
}

export function updateFreelancerFeedbackSuccess(
    payload: FreelancerFeedbackItem
): UpdateFreelancerFeedbackSuccessAction {
    return {
        type: UPDATE_FREELANCER_FEEDBACK_SUCCESS,
        payload
    };
}

export function deleteFreelancerFeedbackStart(
    payload: DeleteFreelancerFeedbackStartActionParams
): DeleteFreelancerFeedbackStartAction {
    return {
        type: DELETE_FREELANCER_FEEDBACK_START,
        payload
    };
}

export function deleteFreelancerFeedbackSuccess(
    payload: DeleteFreelancerFeedbackStartActionParams
): DeleteFreelancerFeedbackSuccessAction {
    return {
        type: DELETE_FREELANCER_FEEDBACK_SUCCESS,
        payload
    };
}

export type FreelancerFeedbackAction =
    | AddFreelancerFeedbackStartAction
    | AddFreelancerFeedbackSuccessAction
    | UpdateFreelancerFeedbackStartAction
    | UpdateFreelancerFeedbackSuccessAction
    | DeleteFreelancerFeedbackStartAction
    | DeleteFreelancerFeedbackSuccessAction;
